// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"a8619cf5","632":"0cfc37b0","706":"711ede07","722":"f1eedd58","726":"759a3e6d"}[chunkId] + ".chunk.js";
};